import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErp {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    fetchWhere(name, sortName = "corporate_name", sortValue = "ASC") {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErp (
                        search_filter: "${name}",
                        orderBy: ["${sortName}", "${sortValue}"]
                    ) {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    fetchByErpId(erpId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErp (
                        erp_id: ${erpId}
                    ) {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    fetchOrderBy(column_name, type) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErp (
                        orderBy: ["${column_name}", "${type}"]
                    ) {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    fetchByInstance(instance_id = null) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErp (
                        instance_id: ${instance_id}
                    ) {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    updateErp (
                        id: ${id},
                        corporate_name: "${data.corporate_name}",
                        cnpj: "${data.cnpj}",
                        erp_id: ${data.erp_id},
                        token: "${data.token}",
                        chosen_instances: [${data.chosen_instances}],
                    ) {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    createErp (
                        corporate_name: "${data.corporate_name}",
                        cnpj: "${data.cnpj}",
                        erp_id: ${data.erp_id},
                        token: "${data.token}",
                        callseeder: ${data.callseeder},
                        chosen_instances: [${data.chosen_instances}]
                    ) {
                        id,
                        corporate_name,
                        cnpj,
                        erp_name,
                        hash_code,
                        erp_id,
                        auth
                    }
                }
            `
        })
    },
    delete(id, deleteProducts) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteErp (
                        id: ${id},
                        delete_products: ${deleteProducts}
                    )
                }
            `
        })
    },
    erpProductIntegration(erpId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    productIntegrationErp (
                        id: ${erpId}
                    )
                }
            `
        })
    },
    userIntegration(erpId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    userIntegration (
                        id: ${erpId}
                    )
                }
            `
        })
    },
    fetchInstance(erpId = null) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
          query: `
            query {
                erpInstances (
                erp_id: ${erpId}
              ) {
                id,
                erp {
                    id,
                    erp_name,
                    hash_code
                },
                instance {
                    id,
                    name,
                    activated,
                    reset_finished
                  }
              }
            }
          `
        })
    },
    removeErpInstances(intancesIds) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
          query: `
            mutation {
                deleteErpInstances (
                instances_ids: [${intancesIds}]
              )
            }
          `
        })
    },
    fetchErpTenancy() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErpTenancy {
                        id,
                        name,
                        auth
                    }
                }
            `
        })
    },
    fetchErpTenancyWhere(name, sortName = "name", sortValue = "ASC") {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getErpTenancy (
                        search_filter: "${name}",
                        orderBy: ["${sortName}", "${sortValue}"]
                    ) {
                        id,
                        name,
                        auth
                    }
                }
            `
        })
    },
}